import {
  createContent,
  formatAssetAmount,
  ordinalIndicator,
} from '@altify/utils';
import { getWeekdayName } from '../../helpers/weekdays';
import { RecurringBuySchedule } from '../../models/RecurringBuySchedule';

export const content = createContent({
  en: {
    youWillBeBuying: "You'll be Buying",
    youAreUsing: "You're Using",
    confirmDetails: 'Confirm Details',
    editDetails: 'Edit Details',
    confirmBuy: 'Confirm Buy',
    recurringScheduleNow: (schedule: RecurringBuySchedule) => {
      if (!schedule) {
        return '';
      }
      const buyToday = schedule.buyNow ? 'Now, then ' : '';
      return schedule.interval === 'weekly'
        ? `${buyToday}Weekly on a ${getWeekdayName(schedule.dayOfWeek, 'en')}`
        : `${buyToday}Monthly on the ${schedule.dayOfMonth}${ordinalIndicator(
          schedule.dayOfMonth,
        )}`;
    },
    infoBox: (
      schedule: RecurringBuySchedule,
      fromAmount: number,
      fromAssetCode: string,
    ) => {
      const amountText = `Please ensure you have ${formatAssetAmount(fromAmount, fromAssetCode, { showSpacer: true })} in your Altify account`;
      const scheduleText =
        schedule.interval === 'weekly'
          ? `before ${getWeekdayName(schedule.dayOfWeek, 'en')} of each week`
          : `before the ${schedule.dayOfMonth}${ordinalIndicator(
            schedule.dayOfMonth,
          )} of each month`;
      const executeText = 'to execute your Recurring Buy order.';

      return `${amountText} ${scheduleText} ${executeText}`;
    },
  },
  de: {
    confirmDetails: 'Details bestätigen',
    confirmBuy: 'Kauf bestätigen',
    editDetails: 'Details bearbeiten',
    youWillBeBuying: 'Du wirst kaufen',
    youAreUsing: 'Du benutzt',
    recurringScheduleNow: (schedule: RecurringBuySchedule) => {
      if (!schedule) {
        return '';
      }
      const buyToday = schedule.buyNow ? 'Jetzt, dann' : '';
      return schedule.interval === 'weekly'
        ? `${buyToday} Wöchentlich an einem ${getWeekdayName(schedule.dayOfWeek, 'de')}`
        : `${buyToday} Monatlich am ${schedule.dayOfMonth}.`;
    },
    infoBox: (
      schedule: RecurringBuySchedule,
      fromAmount: number,
      fromAssetCode: string,
    ) => {
      const beforeText = `Bitte vergewissere dich, dass du vor`;
      const scheduleText =
        schedule.interval === 'weekly'
          ? `${getWeekdayName(schedule.dayOfWeek, 'de')} jeder Woche`
          : `dem ${schedule.dayOfMonth}. eines jeden Monats`;
      const executeText =
        'auf deinem Altify-Konto hast, um deinen wiederkehrenden Kauf auszuführen.';

      return `${beforeText} ${scheduleText} ${formatAssetAmount(fromAmount, fromAssetCode, { showSpacer: true })} ${executeText}`;
    },
  },
});
